import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { FormsModule } from '@angular/forms'

import type { PaginationConfig, PaginationItem } from '../../types/types'

@Component({
  selector: 'dhp-pagination',
  imports: [FormsModule],
  templateUrl: './pagination.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginationComponent {
  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() config!: PaginationConfig

  getPageNumbers(totalPages: number, currentPage: number): PaginationItem[] {
    const items: PaginationItem[] = []

    if (totalPages <= 5) {
      return Array.from({ length: totalPages }, (_, i) => ({
        type: 'page',
        value: i + 1,
      }))
    }

    // Always show first page
    items.push({ type: 'page', value: 1 })

    if (currentPage > 3) {
      items.push({ type: 'ellipsis' })
    }

    // Show pages around current page
    for (
      let i = Math.max(2, currentPage - 1);
      i <= Math.min(totalPages - 1, currentPage + 1);
      i++
    ) {
      items.push({ type: 'page', value: i })
    }

    if (currentPage < totalPages - 2) {
      items.push({ type: 'ellipsis' })
    }

    // Always show last page
    if (totalPages > 1) {
      items.push({ type: 'page', value: totalPages })
    }

    return items
  }

  onPageChange(page: number): void {
    if (page >= 1 && page <= this.config.totalPages) {
      this.config.onPageChange(page)
    }
  }

  onItemsPerPageChange(itemsPerPage: number): void {
    if (this.config.onItemsPerPageChange) {
      this.config.onItemsPerPageChange(itemsPerPage)
    }
  }
}
